var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4765 18.1172L21.7656 24.0156C21.6138 24.2261 21.4291 24.4107 21.2187 24.5625C20.7108 24.9169 20.0836 25.0566 19.4732 24.9514C18.8629 24.8462 18.3186 24.5045 17.9587 24.0005C17.5987 23.4965 17.452 22.8709 17.5504 22.2594C17.6488 21.648 17.9844 21.1 18.4844 20.7344L24.3828 17.0235C24.5169 16.93 24.6764 16.8799 24.8398 16.8799C25.0033 16.8799 25.1628 16.93 25.2969 17.0235C25.4652 17.145 25.5787 17.3283 25.6123 17.5333C25.646 17.7382 25.5972 17.9481 25.4765 18.1172Z",
    fill: "#041018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C10.3359 5 2.49999 12.8281 2.49999 22.4922C2.49406 26.7679 4.05939 30.8967 6.89842 34.0937C6.98436 34.1875 7.06249 34.2812 7.14842 34.3672C7.3333 34.5673 7.55772 34.7269 7.80748 34.8358C8.05724 34.9447 8.32689 35.0006 8.59936 34.9998C8.87183 34.9991 9.14117 34.9418 9.39034 34.8315C9.63951 34.7213 9.86307 34.5605 10.0469 34.3594C11.3137 32.9827 12.8523 31.8838 14.5655 31.1321C16.2787 30.3804 18.1292 29.9923 20 29.9923C21.8708 29.9923 23.7213 30.3804 25.4345 31.1321C27.1477 31.8838 28.6863 32.9827 29.9531 34.3594C30.1369 34.5605 30.3605 34.7213 30.6096 34.8315C30.8588 34.9418 31.1281 34.9991 31.4006 34.9998C31.6731 35.0006 31.9427 34.9447 32.1925 34.8358C32.4423 34.7269 32.6667 34.5673 32.8516 34.3672L33.1016 34.0937C35.9406 30.8967 37.5059 26.7679 37.5 22.4922C37.5 12.8281 29.6641 5 20 5Z",
    stroke: "#041018",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10V12.5",
    stroke: "#041018",
    strokeWidth: 3.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.5H30",
    stroke: "#041018",
    strokeWidth: 3.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.5H7.5",
    stroke: "#041018",
    strokeWidth: 3.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9289 15.4289L11.1609 13.6609",
    stroke: "#041018",
    strokeWidth: 3.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0711 15.4289L28.8391 13.6609",
    stroke: "#041018",
    strokeWidth: 3.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.0f450ae8.svg";
export { ForwardRef as ReactComponent };